import { useCallback, useRef } from "react";
import { useDropzone } from "react-dropzone";


/**
 * File Upload Component
 * @param {*} props 
 * @returns 
 */
export default function FileUpload (props) {
	const {
		width = "100%",
		height = "100%",
		returnResult,
	} = props;

	const mainDiv = useRef(null);

	const onDrop = useCallback(files => {
		resetBgColor();
		returnResult && returnResult(files);
	})
	const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop, multiple: false});

	const setBgColor = () => {
		mainDiv.current.style.backgroundColor= "#8080802e";
	}

	const resetBgColor = () => {
		mainDiv.current.style.backgroundColor= "";
	}

	const onDragLeave = (e) => {
		if(mainDiv.current.contains(e.relatedTarget)) {
			// 하위 객체로 들어온건 무시
			return;
		}
		resetBgColor();
	}


	return (
		<div {...getRootProps()} style={{width: width, height: height, position: "relative"}} onDragEnter={setBgColor} onDragLeave={onDragLeave} onDragEnd={resetBgColor} ref={mainDiv} >
			<input {...getInputProps()} />
			<div className="middle-center">
				이곳에 파일을 Drag 해서 놓거나, 클릭 해서 파일을 선택 하세요.
			</div>
		</div>
	)
}